export default {
  save: 'Salvar',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  complete: 'Completar',
  loadingTip: 'A carregar…',
  vanPagination: {
    prev: 'Anterior',
    next: 'Seguinte',
  },
  vanPullRefresh: {
    pulling: 'Puxar para atualizar...',
    loosing: 'Soltar para atualizar...',
  },
};
